import React, { useState } from 'react';
import tokenapi, { updateWhatsAppQr } from '../../../Base/TokenConfig';
import { downloadQr } from '../../../Utils/downloadQr';
import Message from '../../../Layouts/Message/Message';
import styles from '../my-qr-codes.module.css';

export default function WhatsappDetails(props){
    const singleDetail = props.singleDetail;
    const [title, setTitle] = useState(props.singleDetail.title);
    const [countryCode, setCountryCode] = useState(props.singleDetail.countryCode);
    const [phone, setPhone] = useState(props.singleDetail.phone);
    const [whatsappMessage, setWhatsappMessage] = useState(props.singleDetail.message);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('');

    const updateFunction = (e) => {
        e.preventDefault();
        setLoading(true);
        tokenapi.post(updateWhatsAppQr, {
            qrType: props.singleDetail.qrType,
            categoryId: props.singleDetail.categoryId,
            requestId: props.singleDetail.requestId,
            title: title,
            countryCode: countryCode,
            phone: phone,
            message: whatsappMessage,
            s3Url: props.singleDetail.s3Url,
            encWebUrl: props.singleDetail.encWebUrl
        })
        .then(res => {
            setLoading(false);
            if(res.data.code === 200){
                props.fetchFunction();
                props.closeFunction();
                setMessageType('success');
            } else {
                setMessageType('error');
            }
            setMessage(res.data.message);
        })
        .catch(err => {
            setLoading(false);
            console.error(err);
        })
    }

    return (<>
        {message && <Message type={messageType} message={message} closeMessage={() => setMessage('')} />}
        <div className={styles["vcard-static-content"]}>
            <div>
                <img src={singleDetail.s3Url} alt="qr" />
            </div>
            <div>
                <p><span>Category:</span> {singleDetail.categoryName}</p>
                <p><span>Created on:</span> {`${new Date(singleDetail.createdAt)}`.substr(0, 24)}</p>
                <button className="btn btn-primary" onClick={() => downloadQr(singleDetail.s3Url)}><span className="fa fa-download"></span> Download QR</button>
            </div>
        </div>
        <form onSubmit={updateFunction}>
            <div className={styles["vcard-editable-content"]}>
                <p className={styles["modal-subheading"]}>Edit details</p>
                <label>Title</label>
                <input type="text" placeholder="Enter here" value={title} onChange={(e) => setTitle(e.target.value)} required/>
                <label>Country code</label>
                <input type="text" placeholder="Enter here" value={countryCode} onChange={(e) => setCountryCode(e.target.value)} required/>
                <label>Phone</label>
                <input type="text" placeholder="Enter here" value={phone} onChange={(e) => setPhone(e.target.value)} required/>
                <label>Message</label>
                <input type="text" placeholder="Enter here" value={whatsappMessage} onChange={(e) => setWhatsappMessage(e.target.value)} required/>
                <button className="btn btn-primary mt-3" disabled={loading}>{loading ? 'Wait ...' : 'Submit'}</button>
            </div>
        </form>
    </>)
}